import React from 'react';

export default function HealthCheck() {
    return (
        <div hidden={window.CONFIG['environment.name'] === 'live'} className="health-check">
            <span>Env Name:&nbsp;{window.CONFIG['environment.name']}</span>
            <span>Checksum:&nbsp;{window.CONFIG['healthcheck.property.checksum']}</span>
            <span>Build Date:&nbsp;{window.GITINFO['build_timestamp']}</span>
            <span>Commit:&nbsp;{window.GITINFO['commit_id']}</span>
        </div>
    );
}
